"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Geometry = require("./Geometry");

var _utils = require("../../utils");

var Feature =
/** @class */
function () {
  function Feature(data) {
    if (data === void 0) {
      data = {};
    } // if a geometry object was provided, convert it to a Feature object


    if (data.type && data.coordinates) {
      data = {
        type: 'Feature',
        geometry: data,
        properties: data.properties
      };
    }

    if (!(0, _utils.isEmpty)(data.geometry)) {
      this._geometry = (0, _Geometry.createGeometry)(data.geometry);
      this.properties = data.properties || {};

      if (data.id) {
        this.id = "" + data.id;
      }
    }
  }

  Object.defineProperty(Feature.prototype, "geometry", {
    get: function () {
      return this._geometry;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Feature.prototype, "coordinates", {
    get: function () {
      if (!this.geometry) {
        return undefined;
      }

      return this.geometry.coordinates;
    },
    enumerable: false,
    configurable: true
  });
  return Feature;
}();

var _default = Feature;
exports.default = _default;
module.exports = exports.default;